// extracted by mini-css-extract-plugin
export default {"quotes":"B9Usi7jM1OCys39_Agya","h2":"fzIH7xglUAJMF66PydPw"};